import React from 'react';

import '../../../shared/ui/badge-status.css';

interface Props {
  pendentes: number;
  recusados: number;
  online: boolean;
}

/**
 * O estado NORMAL da fila, como selo no cabeçalho (25/09/2026, pedido do Victor: a faixa cheia
 * dizendo "Tudo enviado" ocupava o espaço mais nobre da tela para avisar que não havia nada a
 * fazer).
 *
 * A regra é a mesma dos radares: o que está em ordem fica quieto, o que precisa de gente fica
 * grande. Com registro pendente ou recusado este selo NÃO aparece — quem assume é a
 * `BarraDeSincronizacao`, de largura inteira, com o "Ver fila". Os dois nunca coexistem: seria
 * dizer "tudo enviado" ao lado de "3 registros no aparelho".
 */
const SeloDeEnvio: React.FC<Props> = ({ pendentes, recusados, online }) => {
  if (pendentes > 0 || recusados > 0) return null;

  return (
    <span style={{ display: 'inline-flex', gap: 6 }}>
      <span className="cilia-badge badge-verde" title="Nenhum registro esperando para subir">
        Tudo enviado
      </span>
      {!online && (
        <span
          className="cilia-badge badge-cinza"
          title="O aparelho está sem rede. Você pode continuar trabalhando."
        >
          Sem rede
        </span>
      )}
    </span>
  );
};

export default SeloDeEnvio;
